import {
  trigger,
  style,
  animate,
  transition,
  keyframes,
  AnimationTriggerMetadata
} from '@angular/animations';

export const animations: AnimationTriggerMetadata[] = [
  trigger('liveDropAnimation', [
    transition('* => go', [
      animate('200ms ease', keyframes([
        style({
          'opacity': 0,
          'margin-left': '-14.9rem'
        }), style({
          'opacity': 1,
          'margin-left': 0
        })
      ]))
    ])
  ])
];